import React, {Component} from 'react';
import {Grid, Icon} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import Dropzone from 'react-dropzone';
import _ from 'lodash';
import REST from 'go/requests/rest';
import {downloadPresignedLink, usePresignedUrl} from 'common/utils';

export class UploadReviewPresentational extends Component {
  renderErrors(messages) {
    return (
      <React.Fragment>
        {!_.isEmpty(messages) && (
          <div className="errorBorderLine">
            <div className="errorMessages">
              {_.map(messages, (message, index) => (
                <p key={index}>
                  <strong>{message.name}:</strong>
                  {message.error}
                </p>
              ))}
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }

  downloadAttachmentLink = (resourceId, fileName) => {
    if (usePresignedUrl()) {
      return (
        <a
          href="#"
          onClick={() => {
            downloadPresignedLink(resourceId);
          }}
          title={`Download ${fileName}`}
        >
          {fileName}
        </a>
      );
    } else {
      const downloadUrl = REST.attachment.getAttachmentDownloadUrl(resourceId);
      return (
        <a href={downloadUrl} title={`Download ${fileName}`}>
          {fileName}
        </a>
      );
    }
  };

  renderSuccesfulRow(file, index) {
    const {fileName, deletable, resourceId} = file;
    const {
      handleDelete,
      showUnsubmittedOnly,
      hideDeleteforNumRequired,
      numRequired,
      hideAction,
    } = this.props;

    const removeAttachmentLink = (
      <a
        className="remove-attachment"
        onClick={(e) => {
          e.preventDefault();
          handleDelete(resourceId);
        }}
        title={`Remove the ${fileName} attachment`}
        href="#"
      >
        <Icon link name="close" color="red" />
        Remove
      </a>
    );

    return (
      <React.Fragment key={index}>
        {showUnsubmittedOnly && deletable && (
          <React.Fragment>
            <Grid.Column width={10}>
              <p>
                {this.downloadAttachmentLink(resourceId, fileName)}
                <Icon name="download" color="black" />
              </p>
            </Grid.Column>
            {!hideAction && (
              <Grid.Column width={6} textAlign="right">
                {(!hideDeleteforNumRequired || filesSuccessful.length > numRequired) &&
                  removeAttachmentLink}
              </Grid.Column>
            )}
          </React.Fragment>
        )}
        {!showUnsubmittedOnly && (
          <React.Fragment>
            <Grid.Column width={10}>
              <p>
                {this.downloadAttachmentLink(resourceId, fileName)}
                <Icon name="download" color="black" />
              </p>
            </Grid.Column>
            {!hideAction && (
              <Grid.Column width={6} textAlign="right">
                {deletable &&
                  (!hideDeleteforNumRequired || filesSuccessful.length > numRequired) &&
                  removeAttachmentLink}
              </Grid.Column>
            )}
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }

  renderFailed(files) {
    const hasErrors = _.filter(files, (file) => file.error !== undefined);
    const errorMessages = _.map(hasErrors, (file) => ({
      name: file.fileName,
      error: file.error,
    }));
    return (
      <Grid.Column width={16}>
        <h4>Failed to Upload:</h4>
        <p>
          <strong>
            {_.map(files, (file) => {
              return file.fileName;
            }).join(', ')}
          </strong>
        </p>
        {this.renderErrors(errorMessages)}
      </Grid.Column>
    );
  }

  renderFileInput() {
    const {acceptedFileTypes, chooseMulti, disabled} = this.props;

    return (
      <Dropzone
        onDrop={(acceptedFiles, rejectedFiles) => {
          return this.props.handleChange(_.concat(acceptedFiles, rejectedFiles));
        }}
        disabled={disabled}
        multiple={chooseMulti}
        onBlur={() => this.props.validate()}
      >
        {({getRootProps, getInputProps, isDragActive}) => {
          let containerClasses = 'dropzone';
          containerClasses = `${containerClasses}${
            isDragActive ? ' dropzone--isActive' : ''
          }`;
          containerClasses = `${containerClasses}${
            disabled ? ' dropzone--disabled' : ''
          }`;
          return (
            <div {...getRootProps()} className={containerClasses}>
              <input
                {...getInputProps()}
                id="attachmentUploadInput"
                title="Upload from your computer"
                accept={acceptedFileTypes}
              />
              <div className="file-drag-zone">
                <p>
                  Drag and drop your files here <br />
                  or <a>choose files</a>
                </p>
              </div>
            </div>
          );
        }}
      </Dropzone>
    );
  }

  render() {
    const {
      filesSuccessful,
      filesFailed,
      fileSizeLimit,
      acceptedFileTypes,
      guidance,
      errorMessages,
    } = this.props;

    const acceptedTypesDescriptor = acceptedFileTypes.join(', ');

    return (
      <Grid
        className={`panel__uploader${
          !_.isEmpty(errorMessages) ? ' errorBorderLine' : ''
        }`}
      >
        <Grid.Column width={16}>
          <p>{guidance}</p>
          {this.renderFileInput()}
          <small>
            <p>
              <strong>Maximum File Size:</strong> {fileSizeLimit + 'MB'}
            </p>
            <p>
              <strong>Accepted File Types:</strong> {acceptedTypesDescriptor}
            </p>
          </small>
        </Grid.Column>
        {!!filesSuccessful.length && (
          <Grid.Row>
            {_.map(_.sortBy(filesSuccessful, ['uploadedDate']), (file, index) =>
              this.renderSuccesfulRow(file, index)
            )}
          </Grid.Row>
        )}
        {!!filesFailed.length && <Grid.Row>{this.renderFailed(filesFailed)}</Grid.Row>}
        {!_.isEmpty(errorMessages) && (
          <Grid.Row>
            <div className="errorMessages">{errorMessages}</div>
          </Grid.Row>
        )}
      </Grid>
    );
  }
}

export default UploadReviewPresentational;
